import { AgencyConfiguration, Agent } from '../../providers/api/dtos';

export function getAgentConfiguration(agent: Agent | undefined): AgencyConfiguration | undefined {
  if (agent) {
    return agent.configuration ?? agent.agencies?.[0]?.configuration;
  }
  return undefined;
}
